import { AppConfigModel } from "../../abstract/app-config.model";

export class LoanInsuranceMode extends AppConfigModel {

    static override CLASS_NAME: string = 'LoanInsuranceMode';
}
